require('./countries-new-container.scss')

module.exports = {
  template: require('./countries-new-container.pug')()
  controller: require('./countries-new-container.ctrl')
}
